import {Znamka} from './znamka';
import {CastStudijnehoPlanu} from './CastStudijnehoPlanu';

export class Predmety {
  znamky: Znamka[];
  castiStudijnehoPlanu: CastStudijnehoPlanu[];
}
